import AuditField from "./AuditField";

export default function BlocFinancier({ data }) {
  return (
    <section className="space-y-6 bg-white p-6 rounded-xl shadow">
      <h2 className="text-xl font-bold text-gray-800">Données Financières</h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <AuditField
          label="Chiffre d'affaires"
          value={data.chiffreAffaires != null ? `${data.chiffreAffaires.toLocaleString()} €` : ""}
        />
        <AuditField
          label="Résultat net"
          value={data.resultatNet != null ? `${data.resultatNet.toLocaleString()} €` : ""}
        />
        <AuditField
          label="Effectif"
          value={data.effectif != null ? `${data.effectif} salarié(s)` : ""}
        />
        <AuditField
          label="Besoin de financement"
          value={data.besoinFinancement != null ? `${data.besoinFinancement.toLocaleString()} €` : ""}
        />
        <AuditField
          label="Projet de financement"
          value={data.projetFinancement}
        />
      </div>
    </section>
  );
}
